import { Collection } from '@/kernel/collection';

import StringCell from '@/components/cells/string-cell.vue';
import DateCell from '@/components/cells/date-cell.vue';
import BooleanCell from '@/components/cells/boolean-cell.vue';
import EditCollectionCell from '@/components/cells/edit-collection-cell.vue';

import { DateRangeFilterAdapter, MultipleRelationInputAdapter } from '@/kernel/adapters';

import DateRangeInput from '@/components/inputs/date-range-input.vue';
import TextInput from '@/components/inputs/text-input.vue';
import CheckboxInput from '@/components/inputs/checkbox-input.vue';
import MultipleRelationInput from '@/components/inputs/multiple-relation-input.vue';

const isPublicOptions = [
  {value: null, label: 'Any'},
  {value: false, label: 'Private'},
  {value: true, label: 'Public'}
];

export class PlatformAsset extends Collection {
  config = {
    autoRoute: true,
    requiresSuperAdmin: true,
    key: 'platform-asset',
    pluralLabel: 'Platform Assets',
    singleLabel: 'Platform Asset',
    indexUrl: '/platform-asset',
    createUrl: '/platform-asset/create',
    searchKeys: ['name', 'isin'],
    editUrlPrefix: '/platform-asset',
    idKey: 'id',
    nameKey: 'name',
    payloadEndpoint: '/platform-asset',
    defaultSort: {
      key: 'name',
      order: 1
    },
    indexColumns: [
      {name: 'Actions', key: 'edit', sortable: false, cell: EditCollectionCell, props: {collection: 'platform-asset'}},
      {name: 'Name', key: 'name', sortable: true, cell: StringCell},
      {name: 'ISIN', key: 'isin', sortable: false, cell: StringCell},
      {name: 'Updated', key: 'updatedAt', sortable: true, cell: DateCell},
      {name: 'Created', key: 'createdAt', sortable: true, cell: DateCell}
    ],
    indexFilters: [
      {key: 'updatedAt', label: 'Updated at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Updated at'}},
      {key: 'createdAt', label: 'Created at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Created at'}}
    ],
    createFormFields: [
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'isin', label: 'ISIN', input: TextInput, props: {label: 'ISIN'}}
    ],
    editFormFields: [
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'isin', label: 'ISIN', input: TextInput, props: {label: 'ISIN'}}
    ]
  }
}
